const clearProposedDiscussion = function ({ commit }) {
  commit("CLEAR_PROPOSED_DISCUSSION");
};

export default clearProposedDiscussion;
